import universal from '../../universal';
import errors from './errors';

export default {
    //#region ERRORS
    "username taken": "Username already taken",
    //#endregion

    create: "create",
    update: "update",
    delete: "delete",
    search: "Search",
    load: "Load",
    no_file_loaded: "No file loaded",

    created: "Created",
    insert: "Insert",
    not: "Not",
    show_hide: "Show/Hide",
    change: "Change",
    visibility: "Visibility",
    polygon: "Polygon",
    make_active: "Activate",
    make_deactivate: "Deactivate",
    enable: "Enable",
    disable: "Disable",
    choose: "Choose",
    select: "Select",
    apply: "Apply",
    rows: "Rows",
    rows_visibility: "Row Visibility",
    existent: "Existing",
    existents: "Existing",
    unexistents: "Non-existing",
    interventions_list: "Interventions List",
    from: "from",
    to: "to",
    row: "Row",
    rows: "Rows",
    elements: "Elements",

    errors,
    universal,

    home: 'Homepage',
    test: 'Test',

    field_data_survey: 'Qualifications',
    field_data_monitor: 'Qualifications Monitor',
    export: 'Export',
    import: 'Import',
    imported: 'Imported',
    fixed_network: 'Fixed Network',
    import_export: 'Import/Export',
    infoworks_export: 'Infoworks Export',
    dat_export: 'Dat Export',

    network_analysis: 'Network Analysis',
    lab_analytics: 'Laboratory Analytics',
    performances: 'Performance',
    trash_by_statistics: 'Trash-By Statistics',

    monitor: 'Monitor',
    consumption_monitor: 'Consumption Monitor',
    district_monitor: 'District Monitor',
    pressure_monitor: 'Pressure Monitor',
    realtime_monitor: 'RealTime Monitor',

    operating_tools: 'Operating Tools',
    user_registries: 'User Registries',
    route_analysis: 'Route Analysis',
    logical_paths: 'Logical Paths',

    workforcemanagement: 'Workforce Management',
    replacement_interventions: 'Replacement Interventions',
    planning: 'Planning',

    synchronization: 'Synchronization',
    qualifications_sync: 'SYNC Qualifications',
    replacements_sync: 'SYNC Replacements',
    walk_by_drive_by_sync: 'SYNC Walk-by/Drive-by',
    WFM_sync: 'SYNC WFM',
    work_force_management: 'Work Force Management',

    work_progress_status: 'Work Progress Status',

    "e-mail": "e-mail",
    wrong_email_password: "wrong email or password",
    login: "Login",
    username: "Username",
    Lastname: "Last Name",
    Firstname: "First Name",
    Role: "Role",
    password: "Password",
    log_in_into_your_account: "Log into your account",
    forgot_password: "Forgot password?",
    reset_password: "Reset password",
    reset: "Reset",
    back_to_login: "Back to Login",
    password_request_completed: 'Password reset request completed successfully.',
    check_your_inbox: 'Check your inbox.',
    didnt_receive_email: 'Didn\'t receive the email?',
    send_again: 'Send again',
    repeat_password: "Repeat password",
    password_reset_request_failed_or_expired: 'Password reset request failed or expired.',
    password_reset_successfully: 'Password has been reset successfully!',
    logout: "Logout",

    editor: "Edit/View",
    viewer: "View Only",
    disabled: "Disabled",

    active: "Active",
    replaced: "Replaced",
    delivered: "Delivered",
    fixed: "Fixed",
    on_fixing: "Being Repaired",
    on_returning: "Being Returned",
    on_delivering: "Being Delivered",
    broken: "Broken",
    returned: "Returned",

    ValidFrom: "Valid From",
    ValidTo: "Valid To",
    Status: "Status",
    OrderRef: "Order Reference",
    DateDelivered: "Delivery Date",
    alarm: 'Alarm',
    alarms: 'Alarms',
    alarmsDictionary: {
        no_alarm: 'NO ALARM',
        BF: 'REVERSE FLOW',
        PE: 'PERSISTENCE',
        BX: 'BATTERY',
        FM: 'SENSOR',
        TP: 'TAMPERING',
        EX: 'EXCESSIVE CONSUMPTION',
        EM: 'HIGH CONSUMPTION',
        RS: 'RESET',
        DF: 'DIRECT FLOW',
        TK: 'TAMPERING RESTORATION',
        RT: 'RESET',
        CR: 'FIRMWARE ERROR',
        PM: 'PROGRAMMING MAGNET',
        MG: 'MAGNETIC TAMPERING',
        MC: 'MECHANICAL TAMPERING',
        RV: 'REVERSE MOUNTED',
        AD: 'AIR DETECTED',
        BP: 'BROKEN PIPE',
        DR: 'DRY',
        MT: 'METROLOGY',
        SS: 'SYSTEM',
        WQ: 'WATER QUALITY',
        PF: 'STOPPED',
        LT: 'LOW TEMPERATURE',
        PX: 'EXCESSIVE PERSISTENCE',
        PP: 'PAST PERSISTENCE',
        PI: 'INTERMITTENT LEAK',
        122: 'DEFAULTER',
        242: 'TERMINATING',
        342: 'TERMINATED',
        306: 'REMOVED',
        132: 'UNKNOWN ALARM',
        116: 'REPLACED',
        206: 'REMOVED',
        999: 'UNKNOWN ALARM',
        ICSE: 'TERMINATION IN PROGRESS',
        CNFA: 'TERMINATED TO BE BILLED',
        CFAT: 'TERMINATED BILLED',
        ICSO: 'SUSPENSION IN PROGRESS',
        SOSP: 'SUSPENDED',
        1: 'SERVICE STATE 1',
        2: 'SERVICE STATE 2',
        3: 'SERVICE STATE 3',
        ES: 'EMPTY PIPE'
    },

    utilities: 'Utilities',
    meter: 'Meter',
    meters: 'Meters',
    smart_meter: 'Smart Meter',
    non_smart: 'Non-Smart',
    towns: 'Towns',
    municipalities: 'Municipalities',
    valid_readings: 'Valid Readings',
    readings: 'Readings',
    active_users: 'Active Users',

    brand: 'Brand',
    brands: 'Brands',

    communication: 'Communication',
    communication_type: 'Communication Type',

    device_type: 'Device Type',

    successfully_added: 'Added successfully!',
    successfully_updated: 'Updated successfully!',
    successfully_removed: 'Removed successfully!',
    successfully_created: 'Created successfully!',
    successfully_imported: 'Imported successfully!',

    server_error: 'Server Error.',

    pick_a_date: 'Pick a date',
    date_format: 'dd/mm/yyyy',
    confirm: 'Confirm',
    selected_days: 'Selected days',

    all_towns: 'All towns',
    all_municipalities: 'All municipalities',

    failed_update_no_changes: `Update failed.\r\nNo changes made to the record.`,

    last_30_days: 'Last 30 days',
    last_7_days: 'Last 7 days',

    language: 'Language',
    back: 'Back',
    cancel: 'Cancel',

    really_want_logout: 'Do you really want to log out?',

    demo: 'Demo',

    error_loading_menu: 'Error while loading the sidebar menu',
    error_logout: 'Error while closing the current session',
    error_saving_language: 'Error while saving the selected language',

    "Lavorazione Sospesa": "Processing Suspended",
    "Sostituito": "Replaced",
    "Mancata Rimozione": "Failed Removal",
    "Mancata Sostituzione": "Failed Replacement",
    "Non Lavorato": "Not Processed",
    "Rimosso": "Removed",

    save: 'Save',

    plan: 'Plan',

    Terminal: 'Terminal',

    installation: 'Installation',
    repair: 'Repair',
    replacement: 'Replacement',
    removal: 'Removal',
    reading: 'Reading',
    georeferencing: 'Georeferencing',

    already_present: 'Already Present',

    you_must_select_an_intervention_type: 'You must first select an intervention type',

    add_to_new_route: 'Add to new route',
    add_to_existing_route: 'Add to selected route',
    add_selected: 'Add Selected',
    remove_selected: 'Remove Selected',

    empty_plan: 'Empty Plan',

    unprocessed: 'Unprocessed',
    attempted_processing: 'Attempted Processing',
    suspended: 'Suspended',
    processed: 'Processed',

    select_a_list: 'Select a list',
    select_operator: 'Select operator',

    identity_code: 'Identity Code',
    accountholder: 'Account Holder',
    email: 'E-mail',
    telephone: 'Telephone',

    registry_details: 'Registry Details',
    intervention: 'Intervention',

    geo: 'Geo',
    geo_data: 'Geographic Data',
    latitude: 'Latitude',
    longitude: 'Longitude',
    altitude: 'Altitude',

    ciu: 'CIU',
    codiceUtente: "CIU",
    idModulo: "Module",
    intestatario: "Account Holder",
    indirizzo: "Address",
    matricola: "Serial Number",
    idTipoUtenza: "Municipality ID",
    lat: "Latitude",
    lng: "Longitude",
    statoInstallazione: "Installed",
    rowNumber: "Row No.",
    plan_id: "Plan ID",

    supply_code: 'Supply Code',

    intervention_type: 'Intervention Type',
    intervention_status: 'Intervention Status',

    old_brand: 'Old Brand',
    new_brand: 'New Brand',
    old_serial: 'Old Serial',
    new_serial: 'New Serial',
    old_reading: 'Old Reading',
    old_reading_date: 'Old Reading Date',
    new_reading: 'New Reading',
    digits_number: 'Number of Digits',
    seal_code: 'Seal Code',
    valve: 'Valve',

    anomaly: "Anomaly",
    anomaly_notes: "Anomaly Notes",

    intervention_specifics: 'Intervention Specifics',
    intervention_result: 'Intervention Result',
    result: 'Result',

    district: 'District',
    address: 'Address',
    municipality: 'Municipality',

    old_location: 'Old Location',
    new_location: 'New Location',

    miscellaneous: 'Miscellaneous',

    causal: 'Causal',
    note: 'Note',
    notes: 'Notes',

    annotation: 'Annotation',
    annotations: 'Annotations',

    all_plans: 'All Plans',
    edit_intervention: 'Edit Intervention',

    exportation: 'Export',
    importation: 'Import',

    preview: 'Preview',
    parameters: 'Parameters',

    select_exportation: 'Select Export',
    start_date: 'Start Date',
    end_date: 'End Date',
    archived_at: 'Archive Date',
    status: 'Status',
    date: 'Date',

    witness: 'Witness Full Name',

    separator: 'Separator',
    format: 'Format',

    trash_by_tools: 'Trash-By Tools',
    trash_by_stats: 'Trash-By Statistics',
    walk_by_drive_by_tools: 'Walk-By/Drive-By Tools',
    assignment: 'Assignment',
    district_metering: 'District Metering',
    geotool: 'Geotool',
    intervention_management: 'Intervention Management',

    press_shift_space_to_switch_working_mode: "To switch working mode, press ",
    designer_mode: 'Designer Mode',
    viewer_mode: 'Viewer Mode',

    procedures: 'Procedures',

    add: 'Add',
    remove: 'Remove',
    edit: 'Edit',

    created_at: 'Created At',
    updated_at: 'Updated At',

    route_generator: 'Logical Route Generator',
    house_number: 'House Number',
    serial_number: 'Serial Number',
    serial: 'Serial',
    identification_number: 'Identification Number',

    create_path: 'Create Path',
    edit_path: 'Edit Path',

    name: 'Name',
    surname: 'Surname',
    firstname: 'First Name',
    lastname: 'Last Name',

    operator: 'Operator',
    anomaly: 'Anomaly',
    anomaly_notes: 'Anomaly Notes',
    type: 'Type',
    supply_type: 'Supply Type',

    intervention_date: 'Intervention Date',
    intervention_start_date: 'Intervention Start Date',
    intervention_end_date: 'Intervention End Date',

    all_photos: 'All Photos',

    gallery: 'Gallery',
    logs: 'Logs',

    you_have_to_select_a_route: 'You must select a route!',

    ok: 'Ok',
    no: 'No',
    yes: 'Yes',

    follow_center: 'Follow Center',
    generated_routes: 'Generated Routes',

    photo: 'Photo',
    photos: 'Photos',

    management: 'Management',

    administrator: 'Administrator',
    admin: 'Administrator',

    delete: 'Delete',

    location: 'Location',
    group: 'Group',
    odi: 'WO',
    id: 'ID',

    period: 'Period',

    module: 'Module',

    end_users: 'End Users',

    create_route: 'Create route',
    insert_interventions: 'Insert interventions on existing plan',
    by_changing_selection_lose_your_progress_proceed: 'By changing selection you will lose all your progress.\nProceed?',

    delete_route: 'Delete route',
    reset_routes: 'Reset routes',

    are_you_sure_wanna_proceed: `Are you sure you want to proceed?`,
    are_you_sure_wanna_delete_route: 'Are you sure you want to delete the selected route?',
    are_you_sure_wanna_reset_routes: 'Are you sure you want to delete all generated routes?',
    are_you_sure_wanna_delete_this_photo: 'Are you sure you want to delete this photo?',

    tips: 'Tips',
    press_ctrl_and_click_to_draw_selection_area: 'Press Ctrl and Click to draw a selection area.',
    double_click_to_reset_selection_area: 'Double click to reset the selection area.',

    notice_date: 'Notice Date',

    end_user: 'End User',

    transmission: 'Transmission',
    transmissions: 'Transmissions',

    environment: 'Environment',
    newMeter: 'New Meter',
    signatureUser: 'Customer Signature',
    oldMeter: 'Old Meter',

    category: 'Category',
    select_a_category: 'Select a Category',

    import_list: 'Import List',

    lists: 'Lists',
    map: 'Map',

    accepted_files: 'Accepted Files',

    drag_and_drop_file_here: 'Drag & Drop a file here',

    kpi: 'KPI',

    stay_logged_in: 'Stay logged in',

    code: 'Code',
    device_not_registered: 'Device not registered',
    check_email_for_code: 'Check your email and enter the code to access',

    you_can_try_login_again_in: `You can try to login again in`,

    yesterday: 'Yesterday',
    realtime: 'Real time',

    red_meters: 'Read Meters',
    active_alarms: 'Active Alarms',

    visualization: 'Visualization',

    reset_selection: 'Reset Selection',

    tabular: 'Tabular',
    archive: 'Archive',

    store: 'Store',
    stored: 'Stored',
    stored_s: 'Stored',
    restore: 'Restore',

    are_you_sure_wanna_delete_plan: 'Are you sure you want to delete the plan?',
    deleting_plan_info: 'By proceeding with removal, operator assignments will be cancelled and it will no longer be possible to restore the plan.',
    are_you_sure_wanna_archive_plan: 'Are you sure you want to archive the plan?',
    archiving_plan_info: 'By proceeding with archiving, operator assignments will be cancelled and it will no longer be possible to view the interventions.',
    are_you_sure_wanna_restore_plan: 'Are you sure you want to restore the plan?',

    proceeding_operation_misalignments_exports: 'Proceeding with the operation could result in misalignments in exports.',

    warning: 'Warning',
    plans: 'Plans',

    plan_assignment: 'Plan Assignment',

    available: 'Available',
    availables: 'Available',

    stored_plans: 'Stored Plans',

    assign_or_remove_plan_before_change_operator: <>Assign or Remove <span className='text-success'>plans</span> for the current Operator before being able to change selection.</>,

    assign_plans: 'Assign Plans',

    are_you_sure_wanna_delete_list: 'Are you sure you want to delete the list?',
    assigned: 'Assigned',
    unassigned: 'Unassigned',

    empty_selection: 'Empty Selection',
    create_new: 'Create New',
    add_move: 'Add/Move',
    interventions: 'Interventions',
    selected: 'Selected',
    selected_s: 'Selected',
    move: 'Move',

    list_name: 'List Name',
    plan_name: 'Plan Name',

    diameter: 'Diameter',
    diameter_mm: 'Diameter (mm)',

    seal: 'Seal',

    //Customization InterventionManagementATENA
    provincia: 'Province',
    posizione_contatore: 'Meter Position',
    luogo_contatore: 'Meter Location'
};